'use strict';

var base = require('../product/base');
var detail = require('../product/detail');
var focusHelper = require('base/components/focus');
var pricingConstants = require('../../../../scripts/constants/PricingConstants');
var displayCartDonateMenuTimeout;

/**
 * Finds the needle in the haystack
 * Alternative to indexOf, since we don't support the native ES6 .includes method
 *
 * @param {object} haystack
 * @param {string} needle
 * @returns {boolean}
 */
function includes(haystack, needle) {
    return haystack.indexOf(needle) !== -1;
}

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl +=
        (newUrl.indexOf('?') !== -1 ? '&' : '?') +
        Object.keys(params)
            .map(function (key) {
                return key + '=' + encodeURIComponent(params[key]);
            })
            .join('&');

    return newUrl;
}

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
    if (data.valid.error) {
        if (data.valid.message && data.valid.message.length > 0) {
            createErrorNotification(data.valid.message);
        } else {
            $('.cart')
                .empty()
                .append(
                    '<div class="row"> ' +
                    '<div class="col-12 text-center"> ' +
                    '<h1>' +
                    data.resources.emptyCartMsg +
                    '</h1> ' +
                    '</div> ' +
                    '</div>'
                );
            $('.number-of-items')
                .empty()
                .append(
                    data.numItems == 1
                        ? data.resources.numberOfItem
                        : data.resources.numberOfItems
                );
            $('.minicart-quantity').empty().append(data.numItems);
            $('.minicart-link').attr({
                'aria-label':
                    data.numItems == 1
                        ? data.resources.numberOfItem
                        : data.resources.numberOfItems,
                title:
                    data.numItems == 1
                        ? data.resources.numberOfItem
                        : data.resources.numberOfItems,
            });
            $('.minicart .popover').empty();
            $('.minicart .popover').removeClass('show');
        }

        $('.checkout-btn').addClass('disabled');
    } else {
        removeDisabledFromCheckoutButton();
    }
}

function removeDisabledFromCheckoutButton() {
    var containsPreOrder = $('#metadata').attr('data-contains-pre-order');
    var minimumQuantityMet = $('#metadata').attr('data-minimum-pre-order-met');

    var okToRemoveDisabled = true;
    if (containsPreOrder && minimumQuantityMet === false) {
        okToRemoveDisabled = false;
    }
    if (okToRemoveDisabled) {
        $('.checkout-btn').removeClass('disabled');
    }
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    $('.number-of-items')
        .empty()
        .append(
            data.numItems == 1
                ? data.resources.numberOfItem
                : data.resources.numberOfItems
        );
    $('.shipping-cost').empty().append(data.totals.totalShippingCost);
    $('.tax-total').empty().append(data.totals.totalTax);
    $('.grand-total').empty().append(data.totals.grandTotal);
    $('.sub-total').empty().append(data.totals.subTotal);
    $('.minicart-quantity').empty().append(data.numItems);
    $('.minicart-link').attr({
        'aria-label':
            data.numItems == 1
                ? data.resources.numberOfItem
                : data.resources.numberOfItems,
        title:
            data.numItems == 1
                ? data.resources.numberOfItem
                : data.resources.numberOfItems,
    });
    if (data.totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').removeClass('hide-order-discount');
        $('.order-discount-total')
            .empty()
            .append('- ' + data.totals.orderLevelDiscountTotal.formatted);
    } else {
        $('.order-discount').addClass('hide-order-discount');
    }

    if (data.totals.shippingLevelDiscountTotal.value > 0) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-discount-total')
            .empty()
            .append('- ' + data.totals.shippingLevelDiscountTotal.formatted);
    } else {
        $('.shipping-discount').addClass('hide-shipping-discount');
    }

    data.items.forEach(function (item) {
        if (item.renderedPromotions) {
            $('.item-' + item.UUID)
                .empty()
                .append(item.renderedPromotions);
        }
        if (item.priceTotal && item.priceTotal.renderedPrice) {
            $('.item-total-' + item.UUID)
                .empty()
                .append(item.priceTotal.renderedPrice);
        }
        if (item.price.type === pricingConstants.PriceTypes.Tiered) {
            var priceSelector = '.line-item-price-' + item.UUID + ' .sales';
            $(priceSelector).each(function () {
                $(this).html('<label class="price__label">Price</label><strong class="price--formatted">' + item.unitPrice.sales.formatted + '</strong>');
                $(this).attr('content', item.unitPrice.sales.decimalPrice);
            });
        }
    });
}

/**
 * Appends an error message to cart-error class
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    if (message !== undefined) {
        var existingErrors =
            document.getElementsByClassName('valid-cart-error');
        var sameErrorExists = false;
        for (var index = 0; index < existingErrors.length; index++) {
            if (existingErrors[index].lastChild.data === message) {
                sameErrorExists = true;
            }
        }

        if (sameErrorExists === false) {
            var errorHtml =
                '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
                'fade show" role="alert">' +
                '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
                '<span aria-hidden="true">&times;</span>' +
                '</button>' +
                message +
                '</div>';

            $('.cart-error').append(errorHtml);
        }
    }
}

function clearErrorNotifications() {
    $('.cart-error').empty();
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
    var html = '';
    $('.approaching-discounts').empty();
    if (approachingDiscounts.length > 0) {
        approachingDiscounts.forEach(function (item) {
            html +=
                '<div class="single-approaching-discount text-center">' +
                item.discountMsg +
                '</div>';
        });
    }
    $('.approaching-discounts').append(html);
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
    var lineItem;
    var messages = '';

    for (var index = 0; index < data.items.length; index++) {
        if (data.items[index].UUID === uuid) {
            lineItem = data.items[index];
            break;
        }
    }

    $('.availability-' + lineItem.UUID).empty();

    if (lineItem.availability) {
        if (lineItem.availability.messages) {
            lineItem.availability.messages.forEach(function (message) {
                messages +=
                    '<p class="line-item-attributes">' + message + '</p>';
            });
        }

        if (lineItem.availability.inStockDate) {
            messages +=
                '<p class="line-item-attributes line-item-instock-date">' +
                lineItem.availability.inStockDate +
                '</p>';
        }
    }

    $('.availability-' + lineItem.UUID).html(messages);
}

/**
 * Finds an element in the array that matches search parameter
 * @param {array} array - array of items to search
 * @param {function} match - function that takes an element and returns a boolean indicating if the match is made
 * @returns {Object|null} - returns an element of the array that matched the query.
 */
function findItem(array, match) {
    for (var index = 0, l = array.length; index < l; index++) {
        if (match.call(this, array[index])) {
            return array[index];
        }
    }
    return null;
}

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateProductDetails(data, uuid) {
    var lineItem = findItem(data.cartModel.items, function (item) {
        return item.UUID === uuid;
    });

    if (lineItem.variationAttributes) {
        var colorAttr = findItem(lineItem.variationAttributes, function (attr) {
            return attr.attributeId === 'color';
        });

        if (colorAttr) {
            var colorSelector = '.Color-' + uuid;
            var newColor = 'Color: ' + colorAttr.displayValue;
            $(colorSelector).text(newColor);
        }

        var sizeAttr = findItem(lineItem.variationAttributes, function (attr) {
            return attr.attributeId === 'size';
        });

        if (sizeAttr) {
            var sizeSelector = '.Size-' + uuid;
            var newSize = 'Size: ' + sizeAttr.displayValue;
            $(sizeSelector).text(newSize);
        }

        var imageSelector =
            '.card.product-info.uuid-' + uuid + ' .item-image > img';
        $(imageSelector).attr('src', lineItem.images.small[0].url);
        $(imageSelector).attr('alt', lineItem.images.small[0].alt);
        $(imageSelector).attr('title', lineItem.images.small[0].title);

        lineItem.variationAttributes.forEach(function (item) {
            var attributeSelctor =
                '.' + item.id + '-' + uuid + ' .attribute-display-value';
            $(attributeSelctor).empty().append(item.displayValue);
        });
    }

    if (lineItem.options && lineItem.options.length) {
        var option = lineItem.options[0];
        var optSelector =
            '.lineItem-options-values[data-option-id="' +
            option.optionId +
            '"]';
        $(optSelector).data('value-id', option.selectedValueId);
        $(optSelector + ' .line-item-attributes').text(option.displayName);
    }

    var qtySelector = '.quantity[data-uuid="' + uuid + '"]';
    $(qtySelector).val(lineItem.quantity);
    $(qtySelector).data('pid', data.newProductId);

    // update step and min values
    $(qtySelector)
        .parent()
        .find('[data-product-field="quantity"]')
        .attr('min', data.minOrderQuantity);
    $(qtySelector)
        .parent()
        .find('.minQuantityValue')
        .text(data.minOrderQuantity);
    $(qtySelector)
        .parent()
        .find('[data-product-field="quantity"]')
        .attr('step', data.stepOrderQuantity);
    $(qtySelector)
        .parent()
        .find('.stepQuantityValue')
        .text(data.stepOrderQuantity);

    $('.remove-product[data-uuid="' + uuid + '"]').data(
        'pid',
        data.newProductId
    );

    var priceSelector = '.line-item-price-' + uuid + ' .sales .value';
    if (lineItem.price.sales !== undefined) {
        $(priceSelector).text(lineItem.price.sales.formatted);
        $(priceSelector).attr('content', lineItem.price.sales.decimalPrice);
    }

    if (lineItem.price.list) {
        var listPriceSelector = '.line-item-price-' + uuid + ' .list .value';
        $(listPriceSelector).text(lineItem.price.list.formatted);
        $(listPriceSelector).attr('content', lineItem.price.list.decimalPrice);
    }

    // check if tiered pricing
    var tieredElement = $('.line-item-price-' + uuid).find(
        '.js-tiered-price-link'
    );
    if (lineItem.price.type === pricingConstants.PriceTypes.Tiered) {
        if (data.cartModel.tieredTablesHtml !== undefined) {
            tieredElement
                .parent()
                .parent()
                .find('.modal-body')
                .empty()
                .append(data.cartModel.tieredTablesHtml);
            tieredElement.removeClass('hidden');
        }
    } else if (tieredElement !== undefined && tieredElement.length > 0) {
        tieredElement.addClass('hidden');
    }

    // update Title
    $('.line-item-name.uuid-' + uuid).text(lineItem.productName);
}

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#editProductModal').length !== 0) {
        $('#editProductModal').remove();
    }
    var htmlString =
        '<!-- Modal -->' +
        '<div class="modal fade" id="editProductModal" tabindex="-1" role="dialog">' +
        '<span class="enter-message sr-only" ></span>' +
        '<div class="modal-dialog quick-view-dialog">' +
        '<!-- Modal content-->' +
        '<div class="modal-content">' +
        '<div class="modal-header">' +
        '    <button type="button" class="close pull-right" data-dismiss="modal">' +
        '        <span aria-hidden="true">&times;</span>' +
        '        <span class="sr-only"> </span>' +
        '    </button>' +
        '</div>' +
        '<div class="modal-body"></div>' +
        '<div class="modal-footer"></div>' +
        '</div>' +
        '</div>' +
        '</div>';
    $('body').append(htmlString);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 */
function fillModalElement(editProductUrl) {
    $('.modal-body').spinner().start();
    $.ajax({
        url: editProductUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $('#editProductModal .modal-body').empty();
            $('#editProductModal .modal-body').html(parsedHtml.body);
            $('#editProductModal .modal-footer').html(parsedHtml.footer);
            $('#editProductModal .modal-header .close .sr-only').text(
                data.closeButtonText
            );
            $('#editProductModal .enter-message').text(data.enterDialogMessage);
            $('#editProductModal').modal('show');

            var items = document.getElementsByClassName(
                'btn-variation-attribute'
            );
            for (var index = 0; index < items.length; index++) {
                if (items[index].attributes.selected) {
                    items[index].classList.remove('btn-outline-info');
                    items[index].classList.add('btn-info');
                    //items[index].classList.remove('btn-outline-light');
                    //items[index].classList.add('btn-light');
                    items[index].classList.add('js-info-active');

                    // logic to build out donate/login link
                    detail.setDonationUrl(items[index], '', '');
                }
            }

            $.spinner().stop();
        },
        error: function (err) {
            $.spinner().stop();
            // Hide blank modal
            if (($('#editProductModal').data('bs.modal') || {})._isTransitioning) {
                // If modal is mid-transition, wait for end of transition to hide
                $('#editProductModal').on('shown.bs.modal', function () {
                    $('#editProductModal').modal('hide');
                });
            } else {
                // If modal is not transitioning, hide immediately
                $('#editProductModal').modal('hide');
            }
            //Show error message, if provided
            // createErrorNotification(JSON.stringify(err));
            if (err.responseJSON) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else if (err.responseJSON.errorMessage) {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        },
    });
}

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 */
function confirmDelete(actionUrl, productID, productName, uuid) {
    var $deleteConfirmBtn = $('.cart-delete-confirmation-btn');
    var $productToRemoveSpan = $('.product-to-remove');

    $deleteConfirmBtn.data('pid', productID);
    $deleteConfirmBtn.data('action', actionUrl);
    $deleteConfirmBtn.data('uuid', uuid);

    $productToRemoveSpan.empty().append(productName);
}

/**
 * Checks for valid email address
 * @param email email address
 * @return whether the email address is valid or not
 */
function validateEmail(email) {
    var validationConstants =
        require('../../../../scripts/constants/ValidationConstants').RegEx;
    return validationConstants.emailAddress.test(email);
}

/**
 * Checks quantity input to see if it meets the minimum value and step requirements.
 *
 * @return {object} json object of boolean values for whether the the quantity meets the minimum value, meets the step requirements, and meets both
 */
function getQuantityInfoCart(currentElement) {
    var quantity = $(currentElement).val();
    var minOrderQuantity = parseInt($(currentElement).attr('min'), 10);
    var stepQuantity = parseInt($(currentElement).attr('step'), 10);

    var quantityInfo = {
        QuantityMeetsMinimumAValue: quantity >= minOrderQuantity,
        QuantityMeetsStepValue: quantity % stepQuantity === 0,
        QuantityMeetsMinimumAndStepValues:
            quantity >= minOrderQuantity && quantity % stepQuantity === 0,
    };
    return quantityInfo;
}

/**
 * Logic for whether to disable the ATC button for donation, from the donation modal in cart
 *
 * @param {*} disabled
 */
function toggleDonationModal(disabled) {
    if (disabled) {
        $('.donation-to-login-modal').addClass('disabled');
        $('.donate-to-cart-modal').addClass('disabled');
    } else {
        $('.donation-to-login-modal').removeClass('disabled');
        $('.donate-to-cart-modal').removeClass('disabled');
    }
}

module.exports = function () {
    $('body').on('click', '.remove-product', function (e) {
        e.preventDefault();

        var actionUrl = $(this).data('action');
        var productID = $(this).data('pid');
        var productName = $(this).data('name');
        var uuid = $(this).data('uuid');
        confirmDelete(actionUrl, productID, productName, uuid);

        dataLayerHandler.pushToDataLayerWithClient(
            $(this).data('push-event-on-remove')
        );
    });

    $('body').on('afterRemoveFromCart', function (e, data) {
        e.preventDefault();
        confirmDelete(
            data.actionUrl,
            data.productID,
            data.productName,
            data.uuid
        );
    });

    $('.optional-promo').click(function (e) {
        e.preventDefault();
        $('.promo-code-form').toggle();
    });

    $('body').on('click', '.cart-delete-confirmation-btn', function (e) {
        e.preventDefault();

        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var urlParams = {
            pid: productID,
            uuid: uuid,
        };

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                if (data.basket.items.length === 0) {
                    $('.cart')
                        .empty()
                        .append(
                            '<div class="row"> ' +
                            '<div class="col-12 text-center"> ' +
                            '<h1>' +
                            data.basket.resources.emptyCartMsg +
                            '</h1> ' +
                            '</div> ' +
                            '</div>'
                        );
                    $('.number-of-items')
                        .empty()
                        .append(
                            data.numItems == 1
                                ? data.basket.resources.numberOfItem
                                : data.basket.resources.numberOfItems
                        );
                    $('.minicart-quantity')
                        .empty()
                        .append(data.basket.numItems);
                    $('.minicart-link').attr({
                        'aria-label':
                            data.basket.numItems == 1
                                ? data.basket.resources.numberOfItem
                                : data.basket.resources.numberOfItems,
                        title:
                            data.basket.numItems == 1
                                ? data.basket.resources.numberOfItem
                                : data.basket.resources.numberOfItems,
                    });
                    $('.minicart .popover').empty();
                    $('.minicart .popover').removeClass('show');
                    $('body').removeClass('modal-open');
                    $('html').removeClass('veiled');
                } else {
                    if (
                        data.toBeDeletedUUIDs &&
                        data.toBeDeletedUUIDs.length > 0
                    ) {
                        for (
                            var index = 0;
                            index < data.toBeDeletedUUIDs.length;
                            index++
                        ) {
                            $('.uuid-' + data.toBeDeletedUUIDs[index]).remove();
                        }
                    }
                    $('.uuid-' + uuid).remove();
                    if (!data.basket.hasBonusProduct) {
                        $('.bonus-product').remove();
                    }
                    $('.coupons-and-promos')
                        .empty()
                        .append(data.basket.totals.discountsHtml);
                    updateCartTotals(data.basket);
                    updateApproachingDiscounts(
                        data.basket.approachingDiscounts
                    );
                    $('body').trigger(
                        'setShippingMethodSelection',
                        data.basket
                    );
                    validateBasket(data.basket);
                }

                $('body').trigger('cart:update');

                $.spinner().stop();
                //reset basket data on Einstein
                // Safety check to ensure the Einstein array is available
                window._etmc = window._etmc || [];

                var einsteinProducts = [];

                // Check if the cart has items in the response
                if (data && data.basket && data.basket.items && data.basket.items.length > 0) {

                    // Loop through the JSON array returned by the AJAX call
                    var items = data.basket.items;
                    for (var i = 0; i < items.length; i++) {
                        einsteinProducts.push({
                            "item": items[i].id,
                            "quantity": items[i].quantity ? items[i].quantity : items[i].quantityOptions ? items[i].quantityOptions.minOrderQuantity : 1,
                            "price": items[i].price.sales.value,
                            "unique_id": items[i].id
                        });
                    }

                    // Fire the event with the fully rebuilt cart
                    window._etmc.push(["trackCart", { "cart": einsteinProducts }]);

                } else {
                    // If the array is empty (user removed the last item)
                    window._etmc.push(["trackCart", { "clear_cart": true }]);
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            },
        });
    });

    $('body').on('keyup', '.quantity-form > .quantity', function () {
        var preSelectQty = $(this).data('pre-select-qty');
        var quantity = $(this).val();
        var quantityInfo = getQuantityInfoCart(this);

        if (quantityInfo.QuantityMeetsMinimumAndStepValues) {
            var productID = $(this).data('pid');
            var url = $(this).data('action');
            var uuid = $(this).data('uuid');

            var urlParams = {
                pid: productID,
                quantity: quantity,
                uuid: uuid,
            };
            url = appendToUrl(url, urlParams);

            $(this).parents('.card').spinner().start();
            clearErrorNotifications();

            $.ajax({
                url: url,
                type: 'get',
                context: this,
                dataType: 'json',
                success: function (data) {
                    $('.quantity[data-uuid="' + uuid + '"]').val(quantity);
                    $('.coupons-and-promos')
                        .empty()
                        .append(data.totals.discountsHtml);
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    updateAvailability(data, uuid);
                    validateBasket(data);
                    $(this).data('pre-select-qty', quantity);

                    $('body').trigger('cart:update');

                    if (
                        'AllMetMinimumQuantity' in data &&
                        'ContainsPreOrder' in data
                    ) {
                        $('#metadata').attr(
                            'data-minimum-pre-order-met',
                            data.AllMetMinimumQuantity
                        );
                        $('#metadata').attr(
                            'data-contains-pre-order',
                            data.ContainsPreOrder
                        );
                    }

                    $.spinner().stop();
                    if (
                        $(this)
                            .parents('.product-info')
                            .hasClass('bonus-product-line-item') &&
                        $('.cart-page').length
                    ) {
                        location.reload();
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $(this).val(parseInt(preSelectQty, 10));
                        $.spinner().stop();
                    }
                },
            });
        }
    });

    $('.shippingMethods').change(function () {
        var url = $(this).attr('data-actionUrl');
        var urlParams = {
            methodID: $(this).find(':selected').attr('data-shipping-id'),
        };

        $('.totals').spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: urlParams,
            success: function (data) {
                if (data.error) {
                    window.location.href = data.redirectUrl;
                } else {
                    $('.coupons-and-promos')
                        .empty()
                        .append(data.totals.discountsHtml);
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                }
                $.spinner().stop();
            },
            error: function (err) {
                if (err.redirectUrl) {
                    window.location.href = err.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            },
        });
    });

    $('.promo-code-form').submit(function (e) {
        e.preventDefault();
        $.spinner().start();
        $('.coupon-missing-error').hide();
        $('.coupon-error-message').empty();
        if (!$('.coupon-code-field').val()) {
            $('.promo-code-form .form-control').attr(
                'aria-describedby',
                'missingCouponCode'
            );
            $('.coupon-missing-error').show();
            $.spinner().stop();
            return false;
        }
        var $form = $('.promo-code-form');
        $('.promo-code-form .form-control').removeClass('is-invalid');
        $('.coupon-error-message').empty();

        $.ajax({
            url: $form.attr('action'),
            type: 'GET',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                if (data.error) {
                    $('.promo-code-form .form-control').addClass('is-invalid');
                    $('.promo-code-form .form-control').attr(
                        'aria-describedby',
                        'invalidCouponCode'
                    );
                    $('.coupon-error-message')
                        .empty()
                        .append(data.errorMessage);
                } else {
                    $('.coupons-and-promos')
                        .empty()
                        .append(data.totals.discountsHtml);
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);

                    dataLayerHandler.pushToDataLayerWithClient({
                        event: 'promocode',
                        promocode: data.totals.discounts.pop().couponCode,
                    });
                }
                $('.coupon-code-field').val('');
                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.errorMessage);
                    $.spinner().stop();
                }
            },
        });
        return false;
    });

    $('body').on('click', '.remove-coupon', function (e) {
        e.preventDefault();

        var couponCode = $(this).data('code');
        var uuid = $(this).data('uuid');
        var $deleteConfirmBtn = $('.delete-coupon-confirmation-btn');
        var $productToRemoveSpan = $('.coupon-to-remove');

        $deleteConfirmBtn.data('uuid', uuid);
        $deleteConfirmBtn.data('code', couponCode);

        $productToRemoveSpan.empty().append(couponCode);
    });

    $('body').on('click', '.delete-coupon-confirmation-btn', function (e) {
        e.preventDefault();

        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var couponCode = $(this).data('code');
        var urlParams = {
            code: couponCode,
            uuid: uuid,
        };

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $('.coupon-uuid-' + uuid).remove();
                updateCartTotals(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                validateBasket(data);
                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            },
        });
    });
    $('body').on('click', '.cart-page .bonus-product-button', function () {
        $.spinner().start();
        $(this).addClass('launched-modal');
        $.ajax({
            url: $(this).data('url'),
            method: 'GET',
            dataType: 'json',
            success: function (data) {
                base.methods.editBonusProducts(data);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            },
        });
    });

    $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
        $('#chooseBonusProductModal').remove();
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');

        if ($('.cart-page').length) {
            $('.launched-modal .btn-outline-primary').trigger('focus');
            $('.launched-modal').removeClass('launched-modal');
        } else {
            $('.product-detail .add-to-cart').focus();
        }
    });

    $('body').on(
        'click',
        '.cart-page .product-edit .edit, .cart-page .bundle-edit .edit',
        function (e) {
            e.preventDefault();

            var editProductUrl = $(this).attr('href');
            getModalHtmlElement();
            fillModalElement(editProductUrl);
        }
    );

    $('body').on('shown.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'true');
        $('#editProductModal .close').focus();
    });

    $('body').on('hidden.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'false');
    });

    $('body').on('keydown', '#editProductModal', function (e) {
        var focusParams = {
            event: e,
            containerSelector: '#editProductModal',
            firstElementSelector: '.close',
            lastElementSelector: '.update-cart-product-global',
            nextToLastElementSelector: '.modal-footer .quantity-select',
        };
        focusHelper.setTabNextFocus(focusParams);
    });

    $('body').on('product:updateAddToCart', function (e, response) {
        // update global add to cart (single products, bundles)
        var dialog = $(response.$productContainer).closest(
            '.quick-view-dialog'
        );

        $('.update-cart-product-global', dialog).attr(
            'disabled',
            !$('.global-availability', dialog).data('ready-to-order') ||
            !$('.global-availability', dialog).data('available')
        );
        // update local add to cart (for sets)
        $('button.add-to-cart', response.$productContainer).attr(
            'disabled',
            !response.product.readyToOrder || !response.product.available
        );

        var enable = $('.product-availability')
            .toArray()
            .every(function (item) {
                return (
                    $(item).data('available') && $(item).data('ready-to-order')
                );
            });
        $('button.add-to-cart-global').attr('disabled', !enable);
    });

    $('body').on('product:updateAvailability', function (e, response) {
        // bundle individual products
        $('.product-availability', response.$productContainer)
            .data('ready-to-order', response.product.readyToOrder)
            .data('available', response.product.available)
            .find('.availability-msg')
            .empty()
            .html(response.message);

        var dialog = $(response.$productContainer).closest(
            '.quick-view-dialog'
        );

        if ($('.product-availability', dialog).length) {
            // bundle all products
            var allAvailable = $('.product-availability', dialog)
                .toArray()
                .every(function (item) {
                    return $(item).data('available');
                });

            var allReady = $('.product-availability', dialog)
                .toArray()
                .every(function (item) {
                    return $(item).data('ready-to-order');
                });

            $('.global-availability', dialog)
                .data('ready-to-order', allReady)
                .data('available', allAvailable);

            $('.global-availability .availability-msg', dialog)
                .empty()
                .html(
                    allReady
                        ? response.message
                        : response.resources.info_selectforstock
                );
        } else {
            // single product
            $('.global-availability', dialog)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);
        }
    });

    $('body').on('product:afterAttributeSelect', function (e, response) {
        if ($('.modal.show .product-quickview .bundle-items').length) {
            $('.modal.show')
                .find(response.container)
                .data('pid', response.data.product.id);
            $('.modal.show')
                .find(response.container)
                .find('.product-id')
                .text(response.data.product.id);
        } else {
            $('.modal.show .product-quickview').data(
                'pid',
                response.data.product.id
            );
        }
    });

    $('body').on('change', '.quantity-select', function () {
        var selectedQuantity = $(this).val();
        $('.modal.fade.show .update-cart-url').data(
            'selected-quantity',
            selectedQuantity
        );
    });

    $('body').on('change', '.options-select', function () {
        var selectedOptionValueId = $(this)
            .children('option:selected')
            .data('value-id');
        $('.modal.show .update-cart-url').data(
            'selected-option',
            selectedOptionValueId
        );
    });

    $('body').on('click', '.update-cart-product-global', function (e) {
        e.preventDefault();
        var updateProductUrl = $(this)
            .closest('.cart-and-ipay')
            .find('.update-cart-url')
            .val();
        var selectedQuantity = $(this)
            .closest('.cart-and-ipay')
            .find('.update-cart-url')
            .data('selected-quantity');
        var selectedOptionValueId = $(this)
            .closest('.cart-and-ipay')
            .find('.update-cart-url')
            .data('selected-option');
        var uuid = $(this)
            .closest('.cart-and-ipay')
            .find('.update-cart-url')
            .data('uuid');
        var customAmount = '';
        var btnOtherElement = document.getElementsByClassName('btn-other');
        if (
            btnOtherElement !== undefined &&
            btnOtherElement.length > 0 &&
            includes(btnOtherElement[0].className, 'js-info-active')
        ) {
            customAmount = $('.donation-other-amount').val();
        }

        var form = {
            uuid: uuid,
            pid: base.getPidValue($(this)),
            quantity: selectedQuantity,
            selectedOptionValueId: selectedOptionValueId,
            customAmount: customAmount,
        };

        clearErrorNotifications();
        $(this).parents('.card').spinner().start();
        if (updateProductUrl) {
            $.ajax({
                url: updateProductUrl,
                type: 'post',
                context: this,
                data: form,
                dataType: 'json',
                success: function (data) {
                    $('#editProductModal').modal('hide');
                    $.spinner().start();
                    $('.coupons-and-promos')
                        .empty()
                        .append(data.cartModel.totals.discountsHtml);
                    updateCartTotals(data.cartModel);
                    updateApproachingDiscounts(
                        data.cartModel.approachingDiscounts
                    );
                    updateAvailability(data.cartModel, uuid);
                    updateProductDetails(data, uuid);

                    if (data.uuidToBeDeleted) {
                        $('.uuid-' + data.uuidToBeDeleted).remove();
                    }

                    validateBasket(data.cartModel);

                    $('body').trigger('cart:update');

                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                },
            });
        }
    });

    $('body').on('keyup', '.billing-email', function (e) {
        e.preventDefault();
        var email = $('.billing-email').val();
        if (!validateEmail(email)) {
            $('.billing-email').addClass('is-invalid');
            $('.billing-email')
                .siblings('.invalid-feedback')
                .removeClass('hidden');
            $('.submit-payment').addClass('disabled');
        } else {
            var billingEmailElement =
                document.getElementsByClassName('billing-email');
            if (
                billingEmailElement !== undefined &&
                billingEmailElement.length > 0 &&
                includes(billingEmailElement[0].className, 'is-invalid')
            ) {
                $('.billing-email').removeClass('is-invalid');
                $('.billing-email')
                    .siblings('.invalid-feedback')
                    .addClass('hidden');
                $('.submit-payment').removeClass('disabled');
            }
        }
    });

    $('body').on('keyup', '[data-product-field="quantity"]', function (e) {
        var quantityInfo = getQuantityInfoCart(this);
        var updateBtnDisabled = document.getElementsByClassName(
            'update-cart-product-global'
        );
        var checkoutBtnDisabled =
            document.getElementsByClassName('checkout-btn');
        var notModal = $(this).closest('.modal-content').length === 0;

        if (quantityInfo.QuantityMeetsMinimumAValue) {
            if (
                !$(this).parent().find('.minQuantityError').hasClass('hidden')
            ) {
                $(this).parent().find('.minQuantityError').addClass('hidden');
            }

            if (quantityInfo.QuantityMeetsStepValue) {
                if (
                    !$(this)
                        .parent()
                        .find('.stepQuantityError')
                        .hasClass('hidden')
                ) {
                    $(this)
                        .parent()
                        .find('.stepQuantityError')
                        .addClass('hidden');
                }
                if (
                    updateBtnDisabled !== undefined &&
                    updateBtnDisabled.length > 0 &&
                    includes(updateBtnDisabled[0].className, 'disabled')
                ) {
                    $('.update-cart-product-global').removeClass('disabled');
                }
                if (notModal) {
                    var $productContainer = $(this).closest('.product-detail');
                    if (!$productContainer.length) {
                        $productContainer = $(this)
                            .closest('.modal-content')
                            .find('.product-quickview');
                    }
                    var url = '';
                    if (
                        $(e.currentTarget).find('option').data('url') !==
                        undefined &&
                        $(e.currentTarget).find('option').data('url') !== null
                    ) {
                        url = $(e.currentTarget).find('option').data('url');
                    } else if (
                        $('.initial-quantity-url').val() !== undefined &&
                        $('.initial-quantity-url').val() !== null
                    ) {
                        url = $('.initial-quantity-url').val();
                    }
                    base.attributeSelect(url, $productContainer);
                }
                if (!notModal) {
                    // update desktop and mobile quantity fields
                    $('.modal-content')
                        .find('[data-product-field="quantity"]')
                        .attr('value', $(this).val());
                }
            } else {
                $(this)
                    .parent()
                    .find('.stepQuantityError')
                    .removeClass('hidden');
                if (
                    updateBtnDisabled !== undefined &&
                    updateBtnDisabled.length > 0 &&
                    !includes(updateBtnDisabled[0].className, 'disabled')
                ) {
                    $('.update-cart-product-global').addClass('disabled');
                }
                if (
                    notModal &&
                    checkoutBtnDisabled !== undefined &&
                    checkoutBtnDisabled.length > 0 &&
                    !includes(checkoutBtnDisabled[0].className, 'disabled')
                ) {
                    $('.checkout-btn').addClass('disabled');
                }
            }
        } else {
            $(this).parent().find('.minQuantityError').removeClass('hidden');
            if (
                updateBtnDisabled !== undefined &&
                updateBtnDisabled.length > 0 &&
                !includes(updateBtnDisabled[0].className, 'disabled')
            ) {
                $('.update-cart-product-global').addClass('disabled');
            }
            if (
                notModal &&
                checkoutBtnDisabled !== undefined &&
                checkoutBtnDisabled.length > 0 &&
                !includes(checkoutBtnDisabled[0].className, 'disabled')
            ) {
                $('.checkout-btn').addClass('disabled');
            }

            if (
                !$(this).parent().find('.stepQuantityError').hasClass('hidden')
            ) {
                $(this).parent().find('.stepQuantityError').addClass('hidden');
            }
        }
    });

    $('body').on('click', '.btn-variation-attribute', function (e) {
        if (!$(this).hasClass('js-info-active')) {
            var $tempParent = $(this).parent();
            var $parentAttributes = $tempParent.find(
                '.btn-variation-attribute'
            );
            $parentAttributes.each(function () {
                if ($(this).attr('value').indexOf('DON') !== -1) {
                    // Donate PDP Keeps Info Button Colors
                    $(this).removeClass('btn-info');
                    $(this).removeClass('js-info-active');
                    $(this).addClass('btn-outline-info');
                } else {
                    // Other PDP Uses Light Button Colors
                    $(this).removeClass('btn-light');
                    $(this).removeClass('js-info-active');
                    $(this).addClass('btn-outline-light');
                }
            });
            // Donate PDP Keeps Info Button Colors
            if ($(this).attr('value').indexOf('DON') !== -1) {
                $(this).addClass('btn-info');
                $(this).addClass('js-info-active');
                $(this).removeClass('btn-outline-info');
            }
            // Other PDP Uses Light Button Colors
            else {
                $(this).addClass('btn-light');
                $(this).addClass('js-info-active');
                $(this).removeClass('btn-outline-light');
            }
            var btnValue = $(this).val();
            var isCart =
                document.getElementsByClassName('cart-page-title').length > 0;
            var btnClassList = '';
            if (isCart) {
                btnClassList = document.getElementsByClassName(
                    'update-cart-product-global'
                );
                // logic determining which button (donate or login) to display
                detail.determineWhichButtonToDisplay(
                    btnValue,
                    'update-cart-product-global'
                );
            } else {
                btnClassList =
                    document.getElementsByClassName('donate-to-cart');
                // logic determining which button (donate or login) to display
                detail.determineWhichButtonToDisplay(
                    btnValue,
                    'donate-to-cart'
                );
            }

            if (
                includes(btnValue, 'single') &&
                btnClassList !== undefined &&
                btnClassList.length > 0 &&
                includes(btnClassList[0].className, 'hidden')
            ) {
                $('.update-cart-product-global').removeClass('hidden');
                $('.donate-to-cart').removeClass('disabled');
                $('.donation-to-login').addClass('hidden');
            }

            if (
                !includes(btnValue, '9999') &&
                btnClassList !== undefined &&
                btnClassList.length > 0 &&
                includes(btnClassList[0].className, 'disabled')
            ) {
                $('.update-cart-product-global').removeClass('disabled');
                $('.donate-to-cart').removeClass('disabled');
                $('.donation-to-login').removeClass('disabled');
                $('.donation-other-amount').addClass('hidden');
                $('.donation-other-amount-label').addClass('hidden');
            }

            // logic to build out donate/login link
            detail.getProductIdAndSetDonationUrl($(this));

            // update the button urls with selected variation
            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }
            base.attributeSelect(e.currentTarget.value, $productContainer);
        }
    });

    // Display other amount on page load
    $('body').ready(function () {
        if (
            $('.product-id').text() === 'DON-USA-OTG' ||
            $('.product-id').text() === 'DON-USA-RGM' ||
            $('.product-id').text() === 'DON-USA-RGA'
        ) {
            // On Load
            $('.donate-to-cart').addClass('disabled');
            $('.donation-to-login ').addClass('disabled');
            $('.donation-other-amount-label').removeClass('hidden');
            $('.donation-other-amount').removeClass('hidden');
            // On Click
            $('body').on('click', '.btn-variation-attribute', function (e) {
                e.preventDefault();
                var clickedBtnValue = $(this)[0].dataset.attrValue;
                var donationBtnValue = 9999;
                if (clickedBtnValue != donationBtnValue) {
                    $('.donation-other-amount').addClass('hidden');
                    $('.donation-other-amount-label').addClass('hidden');
                } else {
                    $('.donation-other-amount-label').removeClass('hidden');
                    $('.donation-other-amount').removeClass('hidden');
                }
            });
        }
    });

    $('body').on('click', '.btn-other', function (e) {
        e.preventDefault();
        var donationOtherAmountElement = document.getElementsByClassName(
            'donation-other-amount'
        );
        var donationOtherAmountModalElement =
            $(this).closest('.donation-amount');
        var isCart =
            document.getElementsByClassName('cart-page-title').length > 0;
        // Donation Modal in cart, for when Donation is not in basket
        var isModal =
            document.getElementsByClassName('cart-donate-menu').length > 0;
        var $tempParent = $(this).parent();
        if (
            isModal &&
            donationOtherAmountModalElement !== undefined &&
            donationOtherAmountElement.length > 0 &&
            donationOtherAmountModalElement.find('.donation-other-amount') !==
            undefined &&
            donationOtherAmountModalElement.find('.donation-other-amount')
                .length > 0 &&
            includes(
                donationOtherAmountModalElement
                    .find('.donation-other-amount')
                    .attr('class'),
                'hidden'
            )
        ) {
            $tempParent.find('.donation-other-amount').removeClass('hidden');
            $tempParent
                .find('.donation-other-amount-label')
                .removeClass('hidden');
            toggleDonationModal(true);
        } else if (
            donationOtherAmountElement !== undefined &&
            donationOtherAmountElement.length > 0 &&
            includes(donationOtherAmountElement[0].className, 'hidden')
        ) {
            $tempParent.find('.donation-other-amount').removeClass('hidden');
            $tempParent
                .find('.donation-other-amount-label')
                .removeClass('hidden');
            if (isCart) {
                $('.update-cart-product-global').addClass('disabled');
            } else {
                $('.donate-to-cart').addClass('disabled');
            }
            $('.donation-to-login').addClass('disabled');
        }
    });

    $('body').on('keyup', '.donation-other-amount', function (e) {
        e.preventDefault();
        var isCart =
            document.getElementsByClassName('cart-page-title').length > 0;
        // Donation Modal in cart, for when Donation is not in basket
        var isModal =
            document.getElementsByClassName('cart-donate-menu').length > 0;
        // enforce donation minimum
        if ($(this).val() >= Number($(this).attr('min'))) {
            if (isModal) {
                toggleDonationModal(false);
            } else {
                if (isCart) {
                    $('.update-cart-product-global').removeClass('disabled');
                } // PDP
                else {
                    $('.donate-to-cart').removeClass('disabled');
                }
                $('.donation-to-login').removeClass('disabled');
            }
        } else {
            var atcClass = '';
            if (isModal) {
                atcClass = 'donate-to-cart-modal';
            } else if (isCart) {
                atcClass = 'update-cart-product-global';
            } else {
                atcClass = 'donate-to-cart';
            }
            var btnClassList = document.getElementsByClassName(atcClass);
            if (
                btnClassList !== undefined &&
                btnClassList.length > 0 &&
                !includes(btnClassList[0].className, 'disabled')
            ) {
                $('.' + atcClass).addClass('disabled');
                if (isModal) {
                    $('.donation-to-login-modal').addClass('disabled');
                } else {
                    $('.donation-to-login').addClass('disabled');
                }
            }
        }
        // logic to build out donate/login link
        if (isModal) {
            detail.setDonationUrl(
                $(this),
                $(this).data('attr-value'),
                $(this).val()
            );
        } else {
            detail.setDonationUrl($(this), '', '');
        }
    });

    $('body').on('click', '.donation-update-to-login', function (e) {
        e.preventDefault();

        var updateProductUrl = $(this).attr('href');
        var uuid = $(this)
            .closest('.cart-and-ipay')
            .find('.update-cart-url')
            .data('uuid');

        // remove product
        var removeProductElement = $('.card.product-info.uuid-' + uuid).find(
            '.remove-product'
        );
        var productID = removeProductElement.data('pid');
        var url = removeProductElement.data('action');
        var urlParams = {
            pid: productID,
            uuid: uuid,
        };

        url = appendToUrl(url, urlParams);

        $.spinner().start();
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function () {
                $.spinner().stop();
                // redirect to Login-Show with new product in url
                window.location.href = updateProductUrl;
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            },
        });
    });

    // Donation Modal in cart, for when Donation is not in basket
    $('body').on('click', '.btn-variation-attribute-modal-js', function () {
        if (!$(this).hasClass('js-info-active')) {
            var $tempParent = $(this).parent();
            var $parentAttributes = $tempParent.find(
                '.btn-variation-attribute-modal-js'
            );
            $parentAttributes.each(function () {
                $(this).removeClass('btn-info');
                $(this).removeClass('js-info-active');
                $(this).addClass('btn-outline-info');
            });
            $(this).addClass('btn-info');
            $(this).addClass('js-info-active');
            $(this).removeClass('btn-outline-info');
            var btnClassList = document.getElementsByClassName(
                'donate-to-cart-modal'
            );

            if (
                !$(this).hasClass('btn-other') &&
                btnClassList !== undefined &&
                btnClassList.length > 0 &&
                includes(btnClassList[0].className, 'disabled')
            ) {
                toggleDonationModal(false);
                $tempParent.find('.donation-other-amount').addClass('hidden');
                $tempParent
                    .find('.donation-other-amount-label')
                    .addClass('hidden');
            }
            // logic to build out donate/login link
            var customAmount = $tempParent.find('.donation-other-amount').val();
            detail.setDonationUrl(
                $(this),
                $(this).data('attr-value'),
                customAmount
            );
        }
    });

    var defaultGiftDonationModal = $(
        '.btn-variation-attribute-modal-js.is-default'
    );

    if (defaultGiftDonationModal.length) {
        defaultGiftDonationModal = $(defaultGiftDonationModal[0]);

        var $tempParent = defaultGiftDonationModal.parent();
        var $parentAttributes = $tempParent.find(
            '.btn-variation-attribute-modal-js'
        );
        $parentAttributes.each(function () {
            defaultGiftDonationModal.removeClass('btn-info');
            defaultGiftDonationModal.removeClass('js-info-active');
            defaultGiftDonationModal.addClass('btn-outline-info');
        });
        defaultGiftDonationModal.addClass('btn-info');
        defaultGiftDonationModal.addClass('js-info-active');
        defaultGiftDonationModal.removeClass('btn-outline-info');
        var btnClassList = document.getElementsByClassName(
            'donate-to-cart-modal'
        );

        if (
            !defaultGiftDonationModal.hasClass('btn-other') &&
            btnClassList !== undefined &&
            btnClassList.length > 0 &&
            includes(btnClassList[0].className, 'disabled')
        ) {
            toggleDonationModal(false);
            $tempParent.find('.donation-other-amount').addClass('hidden');
            $tempParent.find('.donation-other-amount-label').addClass('hidden');
        }
        // logic to build out donate/login link
        var customAmount = $tempParent.find('.donation-other-amount').val();
        detail.setDonationUrl(
            defaultGiftDonationModal,
            defaultGiftDonationModal.data('attr-value'),
            customAmount
        );
    }

    // Donation Modal in cart, for when Donation is not in basket
    $('body').on('click', '.cart-donate-update-frequency-js', function () {
        // Display the correct ATC/Login button and disable if necessary
        var $tempParent = $(this).parent();
        var $parentAttributes = $tempParent.find(
            '.cart-donate-update-frequency-js'
        );
        $parentAttributes.each(function () {
            $(this).removeClass('btn-info');
            $(this).addClass('btn-outline-info');
        });
        $(this).addClass('btn-info');
        $(this).removeClass('btn-outline-info');
        var className = $(this).val() + '-donation-js';
        // check if a button has been selected
        var elements = document.getElementsByClassName(className);
        if (
            elements !== undefined &&
            elements.length > 0 &&
            includes(elements[0].className, 'hidden')
        ) {
            $('.donation-amount').addClass('hidden');
            $('.' + className).removeClass('hidden');

            // update ATC button
            var isUserLoggedIn = $('.is-user-logged').val() === 'true';
            var items = elements[0].getElementsByClassName(
                'btn-variation-attribute-modal-js'
            );
            var selectedBtn = '';
            for (var index = 0; index < items.length; index++) {
                if (includes(items[index].className, 'btn-info')) {
                    selectedBtn = items[index];
                }
            }
            var btnClassListLogin = document.getElementsByClassName(
                'donation-to-login-modal'
            );
            var btnClassListCart = document.getElementsByClassName(
                'donate-to-cart-modal'
            );
            var otherAmountElement = $(
                '.' + className + ' .donation-other-amount'
            ).val();
            // monthly button logic
            if (
                includes($(this).val(), 'monthly') &&
                !isUserLoggedIn &&
                btnClassListLogin !== undefined &&
                btnClassListLogin.length > 0
            ) {
                if (includes(btnClassListLogin[0].className, 'hidden')) {
                    $('.donate-to-cart-modal').addClass('hidden');
                    $('.donation-to-login-modal').removeClass('hidden');
                }

                if (selectedBtn !== undefined && selectedBtn !== '') {
                    detail.setDonationUrl(
                        $(selectedBtn),
                        $(selectedBtn).data('attr-value'),
                        otherAmountElement
                    );
                    if (includes(selectedBtn.className, 'btn-other')) {
                        if (
                            (otherAmountElement === undefined ||
                                otherAmountElement === '' ||
                                otherAmountElement < 10) &&
                            !includes(
                                btnClassListLogin[0].className,
                                'disabled'
                            )
                        ) {
                            toggleDonationModal(true);
                        } else {
                            toggleDonationModal(false);
                        }
                    } else {
                        toggleDonationModal(false);
                    }
                } else if (
                    !includes(btnClassListLogin[0].className, 'disabled')
                ) {
                    toggleDonationModal(true);
                }
            }
            // one-time button logic
            if (
                (includes($(this).val(), 'one-time') &&
                    btnClassListCart !== undefined &&
                    btnClassListCart.length > 0) ||
                (includes($(this).val(), 'monthly') && isUserLoggedIn)
            ) {
                if (includes(btnClassListCart[0].className, 'hidden')) {
                    $('.donation-to-login-modal').addClass('hidden');
                    $('.donate-to-cart-modal').removeClass('hidden');
                }
                if (selectedBtn !== undefined && selectedBtn !== '') {
                    detail.setDonationUrl(
                        $(selectedBtn),
                        $(selectedBtn).data('attr-value'),
                        otherAmountElement
                    );
                    if (includes(selectedBtn.className, 'btn-other')) {
                        if (
                            (otherAmountElement === undefined ||
                                otherAmountElement === '' ||
                                otherAmountElement < 10) &&
                            !includes(
                                btnClassListLogin[0].className,
                                'disabled'
                            )
                        ) {
                            toggleDonationModal(true);
                        } else {
                            toggleDonationModal(false);
                        }
                    } else {
                        toggleDonationModal(false);
                    }
                } else if (
                    !includes(btnClassListCart[0].className, 'disabled')
                ) {
                    toggleDonationModal(true);
                }
            }
        }
    });

    base.selectAttribute();
    base.colorAttribute();
    base.removeBonusProduct();
    base.selectBonusProduct();
    base.enableBonusProductSelection();
    base.showMoreBonusProducts();
    base.addBonusProductsToCart();
    base.focusChooseBonusProductModal();
    base.trapChooseBonusProductModalFocus();
    base.onClosingChooseBonusProductModal();
};
